import { ClipboardCheck, FileText, Plus } from '@/shared/ui/icons';
import type { MobileHeaderAction } from './types';

/** Valuation assessment is deferred; only the existing application flow writes. */
export function buildValuationsCreateAction(isCreating = false, applicationCreateLabel = 'New application'): MobileHeaderAction {
  return {
    id: 'interim-create',
    icon: Plus,
    label: 'Create',
    ariaLabel: 'Create',
    group: 'create',
    disabled: isCreating,
    subActions: [
      {
        id: 'valuation-create',
        icon: ClipboardCheck,
        label: 'Valuation',
        sublabel: "Assess someone else's application · Coming later",
        disabled: true,
        onClick: () => {},
      },
      {
        id: 'application-create',
        icon: FileText,
        label: 'Application',
        sublabel: applicationCreateLabel === 'Record application received' ? applicationCreateLabel : 'Apply for payment',
        disabled: isCreating,
        onClick: () => {
          if (!isCreating) window.dispatchEvent(new CustomEvent('interim:create-new'));
        },
      },
    ],
  };
}
